module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( status_date.toLocaleDateString("en-US", {"dateStyle":"medium"}) ))==null?'':_.escape(__t))+
'</td><td>'+
((__t=( description ))==null?'':_.escape(__t))+
'</td>\n';
}
return __p;
};
